import { render, staticRenderFns } from "./AdminShipping.vue?vue&type=template&id=26b214cc&lang=html"
import script from "./AdminShipping.vue?vue&type=script&lang=js"
export * from "./AdminShipping.vue?vue&type=script&lang=js"
import style0 from "./AdminShipping.vue?vue&type=style&index=0&id=26b214cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports